import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export const BatterySwap = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '24', height = '24', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 22 24"
        sx={{
          backgroundColor: (theme) => theme.palette.badge['dark-green'],
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <g id="WindPowerRounded">
          <path
            id="Subtract"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.16601 4.69629C9.16601 4.144 9.61372 3.69629 10.166 3.69629H13.8353C14.3876 3.69629 14.8353 4.144 14.8353 4.69629V5.35362H16.4425C16.9947 5.35362 17.4425 5.80134 17.4425 6.35362V18.2843C17.4425 18.8365 16.9947 19.2843 16.4425 19.2843H7.55859C7.00631 19.2843 6.55859 18.8365 6.55859 18.2843V6.35362C6.55859 5.80134 7.00631 5.35362 7.55859 5.35362H9.16601V4.69629ZM12.5372 7.96228C12.3912 7.87799 12.2087 7.98336 12.2087 8.15195V9.20643C12.2087 9.32738 12.1107 9.42543 11.9897 9.42543L9.37036 9.42543C9.24941 9.42543 9.15136 9.52348 9.15136 9.64444V10.0824C9.15136 10.2034 9.24941 10.3014 9.37036 10.3014H11.9897C12.1107 10.3014 12.2087 10.3995 12.2087 10.5204L12.2087 11.5749C12.2087 11.7435 12.3912 11.8489 12.5372 11.7646L14.7391 10.0531C14.8851 9.9688 14.8851 9.75807 14.7391 9.67378L12.5372 7.96228ZM11.4629 16.6864C11.6089 16.7707 11.7914 16.6653 11.7914 16.4968V15.4423C11.7914 15.3213 11.8894 15.2233 12.0104 15.2233H14.6297C14.7507 15.2233 14.8487 15.1252 14.8487 15.0043V14.5663C14.8487 14.4453 14.7507 14.3473 14.6297 14.3473H12.0104C11.8894 14.3473 11.7914 14.2492 11.7914 14.1283V13.0738C11.7914 12.9052 11.6089 12.7998 11.4629 12.8841L9.26098 14.5956C9.11498 14.6799 9.11498 14.8906 9.26098 14.9749L11.4629 16.6864Z"
            fill={color}
          />
        </g>
      </SvgIcon>
    );
  }
);

BatterySwap.displayName = 'BatterySwap';

export default BatterySwap;
